module.exports = __webpack_public_path__ + "static/img/new_wlwcp.b8683a67.png";